document.addEventListener('alpine:init', () => {
  Alpine.store('image', {
    thumbnails: [],
    index: 0,
    mainImageSrc: '',
    init() {
      this.mainImageSrc = document.querySelector('img.product-header_main-image').src;
      let thumbnailParent = document.querySelector('div.product-header_list');
      this.thumbnails = [...thumbnailParent.querySelectorAll('.product-header_item:not(.ignore)')];
    },
    prevIndex() {
      let newIndex = this.index - 1;
      if (newIndex < 0) {
        newIndex = this.thumbnails.length - 1;
      }
      let imageUrl = document
        .querySelector(`.product-header_item[data-index="${newIndex}"]`)
        .getAttribute('data-full-size-img');
      this.setThumbnailIndex(newIndex, imageUrl);
    },
    nextIndex() {
      let newIndex = this.index + 1;
      if (newIndex > this.thumbnails.length - 1) {
        newIndex = 0;
      }
      let imageUrl = document
        .querySelector(`.product-header_item[data-index="${newIndex}"]`)
        .getAttribute('data-full-size-img');
      this.setThumbnailIndex(newIndex, imageUrl);
    },
    setThumbnailIndex(index, imageSrc) {
      this.index = index;
      this.mainImageSrc = imageSrc;
      this.thumbnails.sort(function (a, b) {
        return a.getAttribute('data-index') - b.getAttribute('data-index');
      });

      var startElementIndex = this.thumbnails.findIndex(function (element) {
        return parseInt(element.getAttribute('data-index')) === index;
      });

      if (startElementIndex !== -1) {
        var part1 = this.thumbnails.slice(startElementIndex);
        var part2 = this.thumbnails.slice(0, startElementIndex);
        this.thumbnails = part1.concat(part2);
      }

      let thumbnailParent = document.querySelector('div.product-header_list');
      thumbnailParent.children[index].scrollIntoView({
        inline: 'start',
        block: 'nearest',
      });

      // update the lightbox index
      $.data($(document).find('.w-lightbox').get(0), '.w-lightbox').index = index;
      $('.product-header_lightbox-link').data('lightbox-index', index);
    },
  });

  Alpine.store('variantPicker', {
    selectedVariantId: '',
    data: null,
    selectedOptions: [],
    bundleData: null,
    setDefaultData(selectedVariantId, handle, selectedOptions) {
      this.selectedVariantId = selectedVariantId;
      this.selectedOptions = selectedOptions;
      let bundleDataEl = document.querySelector('#bundle-product-data');
      if (bundleDataEl != null) {
        this.bundleData = JSON.parse(bundleDataEl.textContent);
      }
      fetch(`${window.Shopify.routes.root}products/${handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          let element = product.variants.filter((element) => element.id == selectedVariantId)[0];
          let image = null;
          let index = null;
          if (element.featured_image != null) {
            image = element.featured_image.src;
            index = element.featured_image.position - 1;
          } else {
            if (product.media != null) {
              image = product.media[0].src;
              index = product.media[0].position - 1;
            }
          }
          this.data = product;
          if (image != null) {
            Alpine.store('image').setThumbnailIndex(index, image);
          }
        });
    },
    changeVariant(changeOption, index) {
      this.selectedOptions[index] = changeOption;
      this.data.variants.some((element) => {
        if (arraysEqual(element.options, this.selectedOptions)) {
          let url = new URL(window.location.href);
          url.searchParams.set('variant', element.id);
          if (element.featured_image) {
            let image = element.featured_image.src;
            let index = element.featured_image.position - 1;
            Alpine.store('image').setThumbnailIndex(index, image);
          }
          window.history.replaceState(window.history.state, '', url.href);
          return true;
        }
      });
      this.renderVariantChange();
    },
    renderVariantChange() {
      let url = new URL(window.location.href);
      let id = document
        .querySelector('main.main-wrapper.product-page > header.shopify-section.section_product-header')
        .id.replace('shopify-section-', '');
      url.searchParams.set('sections', id);
      fetch(url.href)
        .then((res) => res.json())
        .then((data) => {
          let productHeader = document.querySelector(
            'header.shopify-section.section_product-header div.product-header_product-details'
          );
          let newContent = new DOMParser().parseFromString(data[id], 'text/html');

          productHeader.innerHTML = newContent.querySelector(
            'header.shopify-section.section_product-header div.product-header_product-details'
          ).innerHTML;

          let afterpayData = JSON.parse(
            newContent.querySelector('script[type="application/json"]#afterpay-product-data').innerHTML
          );
          for (let [key, value] of Object.entries(afterpayData)) {
            window[key] = value;
          }

          Afterpay.init(jQuery);
        });
    },
  });

  Alpine.data('recommendedProducts', () => ({
    url: '',
    init() {
      this.url = this.$el.getAttribute('data-url');
      fetch(this.url)
        .then((res) => res.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('div.product-slider_mask.w-slider-mask');

          if (recommendations?.innerHTML.trim().length) {
            this.$el.querySelector('div.product-slider_mask.w-slider-mask').innerHTML = recommendations.innerHTML;
            Webflow.destroy();
            Webflow.ready();
          }
        });
    },
  }));

  Alpine.store('priceMatch', false);
  if (window.priceMatchSuccess) {
    Alpine.store('priceMatch', true);
  }
  Alpine.store('enquire', false);
  if (window.enquirySuccess) {
    Alpine.store('enquire', true);
  }
  Alpine.store('enquireHeading', 'Enquire about this product');
  Alpine.store('enquireType', 'EnquireProduct');

  Alpine.data('tooltip', () => ({
    tooltipEl: null,
    init() {
      this.tooltipEl = this.$el;
      let tooltipRect = this.tooltipEl.getBoundingClientRect();
      let windowWidth = window.innerWidth;
      let tooltipRight = tooltipRect.right - windowWidth;

      if (tooltipRight > 0) {
        let offset = tooltipRight;
        this.tooltipEl.style.left = `calc(50% - ${offset}px)`;

        this.tooltipEl.style.setProperty('--left', `calc(50% + ${offset}px)`);
      }
    },
  }));
});

function toggleOverflow() {
  if (document.body.style.overflow == '') {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

document.addEventListener('DOMContentLoaded', function () {
  const lightboxTriggers = document.querySelectorAll('.product-header_main-image');
  if (window.innerWidth > 576) {
    console.log("screen width is ", window.innerWidth);
    lightboxTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.classList && node.classList.contains('w-lightbox-view')) {
                addZoomHandler();
              }
            });

            mutation.removedNodes.forEach((node) => {
              if (node.classList && node.classList.contains('w-lightbox-view')) {
                addZoomHandler();
              }
            });
          });
        });

        observer.observe(document.body, { childList: true, subtree: true });
      });
    });
  }
});

window.lightboxEventListeners = [];
window.ignoreLightboxZoom = false;

function addZoomHandler() {
  let lightboxContainer = document.querySelector(
    "html[data-wf-page='667a34e925fb0289df54dac2'] .w-lightbox-content .w-lightbox-figure"
  );
  let lightboxImage = document.querySelector(
    "html[data-wf-page='667a34e925fb0289df54dac2'] .w-lightbox-content .w-lightbox-image"
  );

  const padding = 40;

  function updateTransformOrigin(e) {
    if (window.ignoreLightboxZoom) {
      return;
    }

    const rect = lightboxContainer.getBoundingClientRect();

    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;

    if (x < padding) x = padding;
    if (x > rect.width - padding) x = rect.width - padding;
    if (y < padding) y = padding;
    if (y > rect.height - padding) y = rect.height - padding;

    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    lightboxImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
  }

  lightboxContainer.addEventListener('touchstart', (e) => {
    window.ignoreLightboxZoom = true;
  });

  lightboxContainer.addEventListener('mouseenter', (e) => {
    lightboxImage.style.transform = "scale(2)";
    updateTransformOrigin(e);
  });

  lightboxContainer.addEventListener('mousemove', (e) => {
    updateTransformOrigin(e);
  });

  lightboxContainer.addEventListener('mouseleave', (e) => {
    lightboxImage.style.transform = "scale(1)";
  })

  lightboxContainer.addEventListener('touchend', (e) => {
    window.ignoreLightboxZoom = false;
  });
}
